import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const cls = "bg-black/30 border-white/15";

export const PlanForm = ({ plan, onClose, onSaved }) => {
  const [f, setF] = useState({ ...plan, link: plan.link || "", chips: plan.chips || [] });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { pid, id, ...body } = f;
      await api.put(`/admin/plans/${plan.pid}`, body);
      toast.success("Plano atualizado!");
      onSaved();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="admin-plan-dialog" className="max-h-[90vh] overflow-y-auto bg-[#0e1120] text-white border-white/10">
        <DialogHeader><DialogTitle>Editar Opção {plan.pid}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Preço (R$)</Label><Input data-testid="plan-price-input" value={f.price} onChange={set("price")} required className={cls} /></div>
            <div><Label>Selo</Label><Input data-testid="plan-tag-input" value={f.tag} onChange={set("tag")} className={cls} /></div>
          </div>
          <div><Label>Título</Label><Input data-testid="plan-title-input" value={f.title} onChange={set("title")} className={cls} /></div>
          <div><Label>Diferencial</Label><Textarea data-testid="plan-text-input" value={f.text} onChange={set("text")} className={cls} /></div>
          <div><Label>Destaques (um por linha)</Label><Textarea data-testid="plan-chips-input" rows={4} value={f.chips.join("\n")} onChange={(e) => setF({ ...f, chips: e.target.value.split("\n") })} className={cls} /></div>
          <div><Label>Link da loja (vazio = WhatsApp)</Label><Input data-testid="plan-link-input" placeholder="https://..." value={f.link} onChange={set("link")} className={cls} /></div>
          <label className="flex items-center gap-3 text-sm"><Switch data-testid="plan-featured-switch" checked={f.featured} onCheckedChange={set("featured")} />Destacar este plano</label>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="ghost" onClick={onClose}>Cancelar</Button>
            <Button data-testid="plan-save-button" type="submit" disabled={busy} className="grad-bg text-white">Salvar</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
